var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.67518 0.896971C8.83149 0.721123 8.9878 0.721123 9.14411 0.896971L13.0128 4.76563C13.1886 4.92194 13.1886 5.07825 13.0128 5.23456L9.14411 9.10322C8.9878 9.27907 8.83149 9.27907 8.67518 9.10322L8.08902 8.54637C7.91317 8.37052 7.91317 8.20444 8.08902 8.04813L10.463 5.76211H0.351696C0.117232 5.76211 0 5.64487 0 5.41041V4.58978C0 4.35532 0.117232 4.23809 0.351696 4.23809H10.463L8.08902 1.95206C7.91317 1.79575 7.91317 1.62967 8.08902 1.45382L8.67518 0.896971Z",
    fill: "#696969"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListarrow);
export default __webpack_public_path__ + "static/media/list arrow.94596e22148801a537baf91d3a813759.svg";
export { ForwardRef as ReactComponent };